import { Component, OnInit } from '@angular/core';

import { WizardService } from '../../../services/wizard/wizard.service';
import { BaseComponent } from '../../base/base.component';

@Component({
    selector: 'wizard-text-input',
    templateUrl: './generic-input.component.html',
    styleUrls: ['../../form-styles.scss']
})
export class GenericInputComponent extends BaseComponent implements OnInit {
    public text = '';

    constructor(public wizardService: WizardService) {
        super();
    }

    ngOnInit() {
        if (this.wizardService.options[this.data.payloadKey]) {
            this.text = this.wizardService.options[this.data.payloadKey];
        }
    }

    updateText(value) {
        this.wizardService.updateOptions({ [this.data.payloadKey]: value });
    }
}
